module.exports = __webpack_public_path__ + "static/media/modal-bg@2x.776213db.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/modal-bg@2x.png
// module id = 900
// module chunks = 0